import React, {Component} from "react";
import ProductDescription from "./ProductDescription";
import Thumbnail from "./Thumbnails";
import serverCalls from "./utils/serverCommunication";
import adobeDTM from "./utils/adobeDTM";
import Notification from "./shared/notification/notification";
import getUserDetails from "./../components/utils/getUserDetails";
import API_CONSTANTS from "./constants/constants";
import GalleonPreview from "./shared/galleonPreview/GalleonPreview";
import CGDRenderer from "./shared/cgdPreview/CGDPreview";
import {getEnvironment} from "./utils/environmantDetection";
import getCIDFromUri from "./utils/getCIDFromUri";
import helpers from "./utils/helper";
import {
    getCommentCount,
    getComments,
    getLikes,
    getShareServiceURL,
    getUsersData,
    updateCommentsCount
} from './../redux/actions';
import {connect} from 'react-redux';
import CONFIG from "../redux/config";
import ProductDscriptionContainer from './shared/ProductDesciptionContainer/ProductDescriptionContainer';
import likesCommentOmnitureCalls from './../redux/utils/likeCommentOmnitureCalls';
import DOMPurify from 'dompurify';

// Smart component which hold all the landing page component in it, this compoent is responsible for accepting data from Backend API and
// push it to the dump component

class LandingPageContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mobileThumbnailUrl: "",
            webThumbnailUrl: "",
            productName: "",
            productDescription: "",
            userName: "",
            error: "",
            shareUrl: "",
            makeMyOwnUrl: "",
            makeMyOwnUrlWeb: "",
            viewMoreProductsUrl: "",
            projectGuid: "",
            userId: "",
            successMessage: "",
            loading: false,
            previewSubtitle: "",
            errorMessage: "",
            previewUrl: "",
            sflySku: "",
            editProjectUrl: "",
            receivedDetails: false,
            productDescriptionInDetails: {
                moreDetails: {}
            },
            isDescriptionAvailable: false,
            likesCommentDataReducer: {
                loadingGettingUserDetails: true,
                userId: null,
                likeMapping: {},
                recievedLikes: false,
                checkedUser: false
            },
            userFirstName: "",
            calledOnce: false,
            isCalledPending: true
        };
        this.baseUrl = "https://www." + getEnvironment("SCRIPT") + "shutterfly.com";
        this.adobeEvents = new adobeDTM();
    }

    checkIfLinkContainsBasePath(url) {
        if (url.indexOf(".com/") > -1) {
            return url;
        } else {
            return window.location.origin + url;
        }
    }

    getProductDescription = () => {
        serverCalls.getProductDescription().then(res => {
            this.setState({
                productDescriptionInDetails: res,
                isDescriptionAvailable: true
            });
        });
    }


    // Lifecycle hook
    componentDidMount() {
        // this.checkPendingActions();
        // this.getUserDetails();
        this.getSharedProductData();
        this.setCommonHeaderUrlLinks();
        this.getProductDescription();
        this.props.getShareServiceURL();
        window.addEventListener('resize', () => {
            this.setState({});
        });

    }

    checkPendingActions() {
        let comments = parseInt(helpers.getLocalStorageByKey('totalComments'));
        if (comments) {
            this.props.updateCommentsCount(comments - 3);
            this.props.getComments(0, comments, this.state.originalSharedProjectGuid);
        }
        helpers.removeLocalStorage('totalComments');


    }

    componentDidUpdate() {
        if (this.state.receivedDetails && !!this.props.user.accessToken && !this.state.calledOnce) {
            this.getIdToken().then((data) => {
                this.getLikes();
                this.getCommentCount();
                if (!helpers.getLocalStorageByKey('totalComments')) {
                    this.getComments();
                }
            })
            .catch((error) => {
                this.setState({
                    calledOnce: true
                });  
            });
            this.setState({
                calledOnce: true
            });
        }
    }

    componentWillReceiveProps = (nextProps) => {
        // if((nextProps.user.accessToken !== this.props.user.accessToken || this.props.user.userNotLoggedIn) && (!this.state.calledOnce)) {
        //   this.getLikes();
        //   this.getCommentCount();
        //   console.log('helpers.getLocalStorageByKey', helpers.getLocalStorageByKey('totalComments'));
        //   // if(!helpers.getLocalStorageByKey('totalComments')) {
        //   //   this.getComments();
        //   // }
        //   this.setState({
        //     calledOnce: true
        //   });
        // }
        if (nextProps.share.shareServiceResponse && !this.props.share.shareServiceResponse) {

            this.downloadShareLibrary(nextProps.share.shareServiceResponse);
        }
        if (nextProps.user.userId && this.state.isCalledPending) {
            this.checkPendingActions();
            this.setState({
                isCalledPending: false
            });
        }
        this.props = nextProps;
    }

    downloadShareLibrary(response) {
        var rootUrl = response.rootUrl;
        var link = document.createElement('link');
        link.id = 'cssId';
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = rootUrl + '/dist/css/share.css';
        link.media = 'all';
        document.head.appendChild(link);
        var url = rootUrl + '/dist/js/share.js';
        var script = document.createElement('script');
        script.src = url;
        document.body.appendChild(script)
    }


    getComments = () => {
        this.props.getComments(this.props.comments.offset, CONFIG.COMMENT_OFFSET, this.state.originalSharedProjectGuid);
    }

    loadMoreComments = () => {
        likesCommentOmnitureCalls.callOmniture('share-product:view more commnets');
        if (this.props.comments.loadingGetComment) {
            return;
        }
        this.getComments();
    }

    postLikeUnLike = () => {
        this.setState({
            likesCommentDataReducer: {
                loadingGettingUserDetails: true,
                userId: null,
                likeMapping: {},
                recievedLikes: true,
                checkedUser: true
            }
        })

    }

    getIdToken = () => {
        return window.$sflyAuth.getIdToken();
    }

    getAccessToken = () => {
        if (window.$sflyAuth && window.$sflyAuth.getCurrentUser()) {
            return window.$sflyAuth.getCurrentUser().accessToken;
        }
        return null; 
    }

    loadFullStoryScript = () => {
        var script = document.createElement("script");
        script.src = "./../src/libs/fullstoryShare.js";
        document.head.appendChild(script);
    }


    //get Likes of the shared projects

    getLikes = () => {
        this.props.getLikes(this.state.originalSharedProjectGuid);
    }

    // get comment count for given shareid
    getCommentCount = () => {
        this.props.getCommentCount(this.state.originalSharedProjectGuid);
    }

    // There is a bug in the common header sign in and sign up links, It is dropping CID during sign in and sign up.
    setCommonHeaderUrlLinks() {
        try {
            const signInUrl =
                "https://accounts." + getEnvironment() + "shutterfly.com/?redirectUri=";
            const signUpUrl =
                "https://accounts." +
                getEnvironment() +
                "shutterfly.com/signup/?redirectUri=";
            document.getElementsByName("&lid=GlobalHeader_Sign up")[0].href =
                signUpUrl + window.location.href;
            document.getElementsByName("&lid=GlobalHeader_Sign in")[0].href =
                signInUrl + window.location.href;
        } catch {
            console.log("Error while setting href link to signin and signup URL");
        }
    }

    // convert first alphabet of string to uppercase and return the string back
    convertToUpperCase(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    // enable consition to show preview modal
    setShowPreviewFlag = value => {
        // this.initializeCDGRender();
        this.setState(
            {
                showPreview: true
            },
            () => {
                /**
                 *  this.previewRef &&
                 typeof this.previewRef.callRender == 'function' &&
                 this.previewRef.callRender();
                 *  */
            }
        );
    };

    putOmnitureJSPData() {
        const {shareId, sflySku} = this.state;
        var defaultBaseADTMD = window.BaseADTMD || {};
        delete defaultBaseADTMD.env;
        if (defaultBaseADTMD.page) {
            defaultBaseADTMD.page.productDetails = {
                sku: sflySku
            };
        } else {
            defaultBaseADTMD.page = {
                productDetails: {
                    sku: sflySku
                }
            };
        }
        defaultBaseADTMD.session.visitorDetails.visitorId = shareId;
        this.adobeEvents.putOmnitureJSPData(window.location, defaultBaseADTMD);
    }

    loadLibraries(params) {
        var src =
            "https://www." +
            getEnvironment("SCRIPT") +
            "shutterfly.com/rest/omnitureDTL/adobeDTM.siteCatalyst.DTL?esch=1";
        var script = document.createElement("script");
        script.setAttribute("src", src);
        script.async = false;
        this.script = script;
        document.getElementsByTagName("head")[0].appendChild(script);
    }

    // Fetch data of sharable product from API and make the object of data
    getSharedProductData() {
        serverCalls.getData("/share/v1/").then(data => {
            if (data != "error") {
                this.loadLibraries();
                this.loadFullStoryScript();
                this.setState(
                    {
                        userName: (!data.userFirstName && !data.userLastName) ? `(User with ID: ${data.userId})'s Project` :  `${this.convertToUpperCase(data.userFirstName || '')} ${this.convertToUpperCase(data.userLastName || '')}'s Project`,
                        mobileThumbnailUrl: data.mobileThumbnailUrl,
                        webThumbnailUrl: data.landingPageThumbnailUrl,
                        productName: data.title,
                        userId: data.userId,
                        productDescription: data.size,
                        shareUrl: data.shareUrl,
                        makeMyOwnUrl: data.makeMyOwnUrl,
                        makeMyOwnUrlWeb:
                            data.editProjectUrl != "" ? data.editProjectUrl : "#",
                        viewMoreProductsUrl: !data.categoryUrl ? "" : this.checkIfLinkContainsBasePath(
                            data.categoryUrl
                        ),
                        projectGuid: data.projectGuid,
                        previewSubtitle: data.previewSubtitle,
                        previewUrl: data.previewUrl,
                        shareId: data.shareId,
                        sflySku: data.sflySku ? data.sflySku : "",
                        productType: data.productType ? data.productType : "",
                        editProjectUrl: data.editProjectUrl ? data.editProjectUrl : "",
                        userFirstName: data.userFirstName || `User with ID: ${data.userId}`,
                        originalSharedProjectGuid: data.originalSharedProjectGuid,
                        receivedDetails: true
                    },
                    () => {
                        this.script.onload = () => {
                            this.putOmnitureJSPData();
                        };
                    }
                );

            } else {
                this.setState({error: "An error occurred!"});
            }
        });
    }

    // Get Type of given product based  on preview URL receives from share-id API
    getProductType = previewUrl => {
        if (previewUrl.indexOf("pb") > -1) {
            return "Photo Book";
        } else if (previewUrl.indexOf("sb") > -1) {
            return "Story Book";
        } else {
            return "Wall Calendar";
        }
    };

    /**
     * @Return: Object containing payload for the Add to cart.
     * @Does: generate Payload for Add to cart
     */
    generateAddToCartPayload = userId => {
        const {projectGuid} = this.state;
        let payload = {
            projectGuid: projectGuid,
            userId: userId,
            quantity: API_CONSTANTS.DEFAULT_ADD_TO_CART_QUANTITY,
            metadata: {} //TODO: check if metadata is mandetory or not
        };
        return payload;
    };

    /**
     * Get loggedIn user details
     */
    isUserLoggedIn = () => {
        return getUserDetails.getData(
            `${window.location.href}&addToCart=true`,
            "share_product_addtocart",
            getCIDFromUri.getData("cid")
        );
    };

    showNotification = (message, timer) => {
        setTimeout(() => {
            this.setState({
                errorMessage: message
            });
        }, timer);
    };
    /**
     * @Params: error: Object
     * returns void
     */
    handleAddToCartError = error => {
        if (error.status === 401) {
            this.showNotification("Please Login to add cart", 0);
            this.showNotification(null, 2000);
        } else {
            this.setState({
                errorMessage:
                    error.response && error.response.message
                        ? error.response.message
                        : "Internal Server Error",
                loading: false
            });
            this.showNotification(null, 0);
        }
    };

    // stops the loader and redirect to the cart page
    handleAddToCartSuccess = () => {
        console.log("add to cart success");
        this.setState({
            loading: false
        });
        window.location.href = API_CONSTANTS.CART_URL;
    };

    // Calls an API to add Project into the cart
    //TODO: Remove Token
    addToCart = dontCall => {
        if (!dontCall) {
            this.adobeEvents.clickDTMEvent("add to cart", window.location, "false");
        }
        this.setState({
            loading: true
        });
        this.isUserLoggedIn().then(userDetails => {
            const { accessToken, email, firstName, lastName, uid } = userDetails.data;
            const user = {
                accessToken: DOMPurify.sanitize(accessToken),
                email: DOMPurify.sanitize(email),
                firstName: DOMPurify.sanitize(firstName),
                lastName: DOMPurify.sanitize(lastName),
                uid: DOMPurify.sanitize(uid),
            }
            if (user && user.uid) {
                const payload = this.generateAddToCartPayload(user.uid); //function returns the payload to pass to add to cart api
                const cartPromise = serverCalls.addToCart(
                    {token: user.accessToken},
                    payload
                );

                cartPromise.then(
                    data => {
                        if (data.error) {
                            this.handleAddToCartError(data);
                        } else {
                            this.handleAddToCartSuccess(data);
                        }
                    },
                    error => {
                        // TODO: handle error
                        console.log("error", error);
                        this.setState({
                            loading: false
                        });
                    }
                );
            }
        });
    };
    // get Edit Url based on preview URL receives from share-id API
    getEditUrl = () => {
        const {previewUrl} = this.state;
        if (previewUrl.indexOf("pb") > -1) {
            return this.baseUrl + "/pb/#/?projectGUID=" + this.state.projectGuid;
        } else if (previewUrl.indexOf("sb") > -1) {
            return this.baseUrl + "/sb/#/?projectGUID=" + this.state.projectGuid;
        } else {
            return this.baseUrl + "/gc/#/?projectGUID=" + this.state.projectGuid;
        }
    };

    closeModal = () => {
        this.setState({
            showPreview: false
        });
    };

    getPreviewUrl = previewUrl => {
        const {shareId, projectGuid, productType} = this.state;
        let type = "";
        if (previewUrl.indexOf("pb") > -1) {
            type = "pb";
        } else if (previewUrl.indexOf("sb") > -1) {
            type = "sb";
        } else if (previewUrl.indexOf("ncp") > -1) {
            if (productType && productType.trim() !== "") {
                return `/ncp/?productType=${productType}&newShareId=${shareId}&headerMode=3&viewMode=preview`;
            } else {
                return `/ncp/?newShareId=${shareId}&headerMode=3&viewMode=preview`;
            }
        } else {
            type = "gc";
        }
        return `/${type}/#/slideshow?promptOnExit=false&allowAutoSave=false&canOrderFromSlideshow=false&newShareId=${shareId}`;
    };
    /**
     * TODO: Noone consuming this utility function, for future scope
     * Render Preview of GCD and Galleon conditionally
     */
    renderPreview = () => {
        let {
            previewTitle,
            previewSubtitle,
            projectGuid,
            userId,
            previewUrl
        } = this.state;
        let element = null;
        const cases = previewUrl ? 'Galleon' : 'CGD';
        // const cases = previewUrl ? "Galleon" : "";
        const newPreviewUrl = this.getPreviewUrl(previewUrl);
        // previewUrl = '/sb/#/slideshow?newShareId=f4e4f688-36de-4c2f-a759-6629dfc2ea97&promptOnExit=false&allowAutoSave=false&canOrderFromSlideshow=false'
        switch (cases) {
            case "Galleon":
                element = (
                    <GalleonPreview
                        src={this.baseUrl + newPreviewUrl}
                        closeModal={this.closeModal}
                        redirectURL={this.getEditUrl()}
                        previewTitle={previewTitle}
                        previewSubtitle={previewSubtitle}
                    />
                );
                break;

            case "CGD":
                element = (
                    <CGDRenderer
                        projectGuid={projectGuid}
                        userId={userId}
                        shareId={this.state.shareId}
                        ref={instance => (this.previewRef = instance)}
                        previewTitle={previewTitle}
                        previewSubtitle={previewSubtitle}
                        closeModal={this.closeModal}
                    />
                );
                break;

            default:
                element = null;
        }
        return element;
    };

    showCGDPreview = () => {
        this.setState({
            showCGD: true
        })
    }

    isSomeInfoAvailable = () => {
        const {details, shortDescription, moreDetails} = this.state.productDescriptionInDetails;
        if (!moreDetails) {
            return false;
        }

        const {size, orientation, photos} = moreDetails;
        return details || shortDescription || (size && size.length > 0) || orientation || photos
    }

    render() {

        const {
            loading, errorMessage, showPreview,
            previewUrl, isDescriptionAvailable,
            shareId, likesCommentDataReducer, recievedLikes
        } = this.state;

        if (this.state.userName.length === 0) {
            return (
                <div className="landing-page-container">
                    <div className="errorMsg">{this.state.error}</div>
                </div>
            );
        } else {
            return (
                <React.Fragment>
                    <div className="landing-page-container">
                        {this.state.errorMessage && (
                            <Notification error="true" message={errorMessage}/>
                        )}

                        <div className="productDetails">
                            <div className="thumb">
                                <Thumbnail
                                    mobileImgUrl={this.state.mobileThumbnailUrl}
                                    webImgUrl={this.state.webThumbnailUrl}
                                    makeMyOwnUrlWeb={this.state.makeMyOwnUrlWeb}
                                    setShowPreviewFlag={this.setShowPreviewFlag}
                                    previewUrl={previewUrl}
                                    shareId={shareId}
                                    likesCommentDataReducer={likesCommentDataReducer}
                                    recievedLikes={recievedLikes}
                                    postLikeUnLike={this.postLikeUnLike}
                                    editProjectUrl={this.state.editProjectUrl}
                                    shareUrl={this.state.shareUrl}
                                    originalSharedProjectGuid={this.state.originalSharedProjectGuid}
                                    productName={this.state.productName}
                                    productOwner={this.state.userName}/>

                            </div>
                        </div>
                        <div className="productDetails product-description">
                            <div className="product-desc-container">
                                <ProductDescription
                                    productName={this.state.productName}
                                    productDescription={this.state.productDescription}
                                    productOwner={this.state.userName}
                                    makeMyOwnUrl={this.state.makeMyOwnUrl}
                                    makeMyOwnUrlWeb={this.state.makeMyOwnUrlWeb}
                                    viewMoreProductsUrl={this.state.viewMoreProductsUrl}
                                    projectGuid={this.state.projectGuid}
                                    addToCart={this.addToCart}
                                    previewSubtitle={this.state.previewSubtitle}
                                    editProjectUrl={this.state.editProjectUrl}
                                    loading={loading}
                                    shareId={shareId}
                                    originalSharedProjectGuid={this.state.originalSharedProjectGuid}
                                    likesCommentDataReducer={likesCommentDataReducer}
                                    postLikeUnLike={this.postLikeUnLike}
                                    shareUrl={this.state.shareUrl}
                                />
                            </div>
                        </div>
                        <div>{showPreview && this.renderPreview()}</div>
                        <div>
                            {
                                this.state.showCGD &&
                                <NewCGDPReview/>
                            }
                        </div>
                    </div>

                    <div className="product-description-container">{


                        <ProductDscriptionContainer
                            productDescriptionInDetails={this.state.productDescriptionInDetails}
                            loadMore={this.loadMoreComments}
                            userName={this.state.userFirstName}
                            userId={this.state.userId}
                            originalSharedProjectGuid={this.state.originalSharedProjectGuid}
                            showProductDetails={this.isSomeInfoAvailable()}/>
                    }
                    </div>


                </React.Fragment>
            );
        }
    }
}


const mapStateToProps = state => {
    return {
        share: state.share,
        comments: state.comments,
        user: state.user
    };
};

const mapDisptchToPorps = {
    getLikes,
    getUsersData,
    getComments,
    getShareServiceURL,
    getCommentCount,
    updateCommentsCount
}

export default connect(mapStateToProps, mapDisptchToPorps)(LandingPageContainer);
